<template>
    <div class="manifest-request-information-details">
        <div class="manifest-request-information-details__row">
            <span class="manifest-request-information-details__label">
                {{ $t('Component(ReceivedRequestViewRequest):product-information-customer') }}
            </span>
            <span class="manifest-request-information-details__value">{{ customer }}</span>
        </div>
        <div class="manifest-request-information-details__row">
            <span class="manifest-request-information-details__label">
                {{ $t('Component(Label):last-response-date') }}
            </span>
            <span class="manifest-request-information-details__value">
                {{ renderDate(request.validTo) }}
            </span>
        </div>
        <div class="manifest-request-information-details__row">
            <span class="manifest-request-information-details__label">
                {{ $t('Component(Text):product') }}
            </span>
            <span class="manifest-request-information-details__value">
                {{ productSummary }}
            </span>
        </div>
    </div>
</template>

<script>
import dateRenderer from '@core/mixins/date-renderer'
import {
    getNameOrId,
    ProductIdentifiers,
    ProductNames,
} from '@/libs/product'

export default {
    name: 'ManifestRequestInformationDetails',
    mixins: [dateRenderer],
    props: {
        request: {
            type: Object,
            required: true,
        },
    },
    computed: {
        customer() {
            return this.request.customer ? this.request.customer.title : ''
        },
        productName() {
            const product = this.request.product || {}
            const names = Array.isArray(product.names) ? product.names : []

            return getNameOrId(names, ProductNames.OUR_PRODUCT_NAME)
                || (names[0] && names[0].value)
                || ''
        },
        productIdentifier() {
            const product = this.request.product || {}
            const identifiers = Array.isArray(product.identifiers) ? product.identifiers : []

            return getNameOrId(identifiers, ProductIdentifiers.PRODUCT_ID)
                || (identifiers[0] && identifiers[0].value)
                || ''
        },
        productSummary() {
            return `${this.productName || '—'} - ${this.productIdentifier || '—'}`
        },
    },
}
</script>

<style scoped lang="scss">
.manifest-request-information-details__row {
    display: grid;
    grid-template-columns: 10rem minmax(0, 1fr);
    align-items: center;
    column-gap: 1rem;

    & + & {
        margin-top: 0.75rem;
    }
}

.manifest-request-information-details__label {
    color: #6e6b7b;
    font-size: 0.9375rem;
    font-weight: 600;
    line-height: 1.35;
}

.manifest-request-information-details__value {
    color: #2f2b3d;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.35;
}

@media (max-width: 575.98px) {
    .manifest-request-information-details__row {
        grid-template-columns: 1fr;
        row-gap: 0.25rem;
    }
}
</style>
